import { useState } from 'react';
import { format } from 'date-fns';
import { RiRouteLine } from 'react-icons/ri';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { showMessage } from 'app/store/fuse/messageSlice';
import GenericInputActionDialog from 'app/admin/common/component/GenericInputActionDialog';
import OptimizationCaseTaskEditService from 'app/admin/taskManager/service/OptimizationCaseTaskEditService';
import OptimizationCaseService from 'app/admin/optimizationCase/service/OptimizationCaseService';

import { useWhatIf } from './WhatIfProvider';

export default function WhatIfOptimizationCaseButton(props) {
	const [openDialog, setOpenDialog] = useState(false);
	const dispatch = useDispatch();

	const { data } = useWhatIf();

	const handleSend = (value) => {
		let meta = {
			'backgroundCalculate': {
				type: 'OPTIMIZE',
				id: props.id
			}
		};

		const state = {};

		if (data.experiment && data.experiment.attributes)
			data.experiment.attributes.forEach(attribute => {
				if (attribute.io === 'INPUT')
					state[attribute.name] = attribute.value;
			});

		if (value && value.optimizationCase)
			OptimizationCaseTaskEditService.save({
				id: null,
				name: value.name,
				type: 'Optimize',
				optimizationCase: value.optimizationCase,
				unitOptimizer: null,
				stateInject: state,
				meta
			})
				.then(response => { handleResponse(response); })
				.catch(err => handleError(err));
		else
			dispatch(showMessage({ message: 'Optimization case missing!' }));
	};

	const handleResponse = (response) => {
		if (response.successful) {
			dispatch(showMessage({ message: 'Successfully added!' }));
			setOpenDialog(false);
		}
		else {
			dispatch(showMessage({ message: 'Error!' }));
		}
	};

	const handleError = () => {
		dispatch(showMessage({ message: 'Error!' }));
	};

	const optimizationCase = data && data.properties
		? data.properties.optimizationCase
		: null;

	return (
		<>
			<Button
				className='whitespace-nowrap mx-4'
				variant='contained'
				color='secondary'
				onClick={() => setOpenDialog(true)}
				startIcon={<RiRouteLine />}
			>
				Optimize
			</Button>

			{openDialog && (
				<GenericInputActionDialog
					title='Optimize'
					buttonLabel='Optimize'
					defaultValues={{
						name: props.name + ' - ' + format(new Date(), 'yyyy.MM.dd. HH:mm:ss').toString(),
						optimizationCase: optimizationCase && optimizationCase.id
							? optimizationCase.id
							: optimizationCase
					}}
					extraFields={[
						{
							key: 'optimizationCase',
							text: 'Optimization Case',
							inputType: 'select',
							topic: 'whatIf',
							required: true,
							hideNull: true,
							items: () => OptimizationCaseService.getListSelection()
						}
					]}
					onCancel={() => setOpenDialog(false)}
					onSave={value => { handleSend(value); }}
				/>
			)}
		</>
	);
}